/**
 * @author      luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { filterActions } from '@zumper/redux-ignore'
import type { ActionTypes as DetailActionTypes } from '../../reducers/types'
import { ratingsReducer as rootReducer } from './reducers/index'
import { whitelist } from './reducers/whitelist'

export { whitelist }
export const ratings = filterActions<
  ReturnType<typeof rootReducer>,
  DetailActionTypes,
  (typeof whitelist)[number]
>(rootReducer, whitelist)
